import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=5a407b7c&"
import script from "./GanttChart.vue?vue&type=script&lang=js&"
export * from "./GanttChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports